import { normalizeConversationSource } from "@/types/conversationSource"

import { DATA_SOURCE, type DataSource } from "../types/core"

/**
 * Resolve the canonical dataSource from a widget config.
 * Handles backward compatibility with the old `monitoring` field.
 */
export function resolveDataSource(config: {
  dataSource?: DataSource
  monitoring?: string
}): DataSource {
  const conversationSource = normalizeConversationSource(
    config.dataSource ?? config.monitoring,
  )
  if (conversationSource) {
    return conversationSource
  }

  switch (config.dataSource ?? config.monitoring) {
    case "human_review":
    case "Labeling":
    case "labeling":
      return DATA_SOURCE.HUMAN_REVIEW
    case undefined:
    default:
      return DATA_SOURCE.SIMULATED
  }
}

/**
 * Whether the data source queries monitoring (production) data.
 */
export function isUploadedConversationSource(ds: DataSource): boolean {
  return ds === DATA_SOURCE.UPLOADED
}

/**
 * Whether the data source queries human review / labeling data.
 */
export function isHumanReviewSource(ds: DataSource): boolean {
  return ds === DATA_SOURCE.HUMAN_REVIEW
}

/**
 * Whether the data source should hide simulation-specific options
 * (groupBy, splitBy, agent/persona/template filters).
 */
export function hideSimulationOptions(ds: DataSource): boolean {
  return ds !== DATA_SOURCE.SIMULATED
}
